import { ExtendedEventBaseItem } from "./extended-event-base.item";
import { SeriesAmateursItem } from "./series-amateurs-item";
import { SeriesAmateursRankingsItems } from "./series-amateurs-rankings.item";
import { FactoryService } from "../../wa-services/factory-service";
import { SeriesAmateursDetailItem } from "./series-amateurs-detail-item";
import { AthleteGeneralInfoItem } from "./athlete-general-info.item";

export class SeriesTeamsRankingItems {
  details: Array<SeriesAmateursDetailItem> = new Array();
  members: Array<AthleteGeneralInfoItem> = new Array();
  rank: number;
  rankold: number;
  cat: string;
  score: number;
  name: string;
  logo:string;
  constructor(SeriesTeamRankingItemraw: any, waHelperService: FactoryService) {
    this.details = SeriesTeamRankingItemraw.Details;
    this.members = SeriesTeamRankingItemraw.Members;
    this.rank = SeriesTeamRankingItemraw.Rnk;
    this.rankold = SeriesTeamRankingItemraw.RnkOld;
    this.score = SeriesTeamRankingItemraw.Score;
    this.name = SeriesTeamRankingItemraw.Name;
    this.logo = SeriesTeamRankingItemraw.Logo;
  }
}
